import apiClient from '@u/apiClient'

export default {
  //region fetch

  async fetchInvoiceItemID({ commit }, payload) {
    await apiClient
      .get(`api/invoicing/invoice-item/${payload.id}`)
      .then(async (response) => {
        await commit('setInvoiceItem', response.data.invoice_item)
        commit('auth/setErrors', {}, { root: true })
      })
      .catch((reason) => {
        console.error('fetchInvoiceItemID reason', reason)
      })
  },
  //endregion

  //region store
  async storeInvoiceItem({ commit }, payload) {
    await apiClient
      .put(`api/invoicing/add-item-fast/${payload.invoiceId}`, {
        item_id: payload.item_id
      })
      .then(async (response) => {
        await commit('setInvoice', response.data.invoice)
      })
      .catch((reason) => {
        console.error('storeInvoiceItem reason', reason)
      })
  },
  //endregion

  //region update
  updateInvoiceItem({ commit }, payload) {
    return apiClient
      .put(`api/invoicing/invoice-item/${payload.id}`, payload.invoice_item)
      .then((response) => {
        commit('setInvoice', response.data.invoice)
        return response.data
      })
  },
  updateMultipleInvoiceItems({ commit }, payload) {
    return apiClient
      .put(
        `api/invoicing/add-multiple-items/${payload.invoiceId}`,
        payload.items
      )
      .then((response) => {
        commit('setInvoice', response.data.invoice)
        return response.data
      })
  },
  //endregion

  //region delete
  deleteInvoiceItem({ commit }, payload) {
    return apiClient
      .delete(`api/invoicing/invoice-item/${payload.id}`, payload.invoice_item)
      .then((response) => {
        commit('setInvoice', response.data.invoice)
        return response.data
      })
  },
  undoDeleteInvoiceItem({ commit }, payload) {
    return apiClient
      .get(`api/invoicing/undo-delete/${payload.id}`)
      .then((response) => {
        commit('setInvoice', response.data.invoice)
        return response.data
      })
  },
  //endregion
  //region order invoice items
  reorderInvoiceItems({ commit }, payload) {
    return apiClient
      .put(`api/invoicing/reorder-items/${payload.invoice_id}`, {
        items: payload.ordered_list
      })
      .then((response) => {
        commit('setInvoice', response.data.invoice)
        return response.data
      })
  }
  //endregion
}
